export const SET_FILE_UPLOADER_STATUS = "SET_FILE_UPLOADER_STATUS";
